import type { DayState } from './state';

/**
 * 進度代碼：
 * - 短代碼（例如 FF-7KQ2-9XMA）：同一台瀏覽器直接輸入就回到該檢查點（快照存在 localStorage）
 * - 完整代碼（FF3: 開頭）：整個進度壓縮後的文字，可以貼到別台電腦／手機繼續
 * 成就與圖鑑不在代碼裡（存在各自瀏覽器的 Profile），所以讀代碼時「今日挑戰」會重新抽。
 */
const ALPH = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
export function shortCode(rnd: () => number = Math.random): string {
  const part = () => Array.from({ length: 4 }, () => ALPH[Math.floor(rnd() * ALPH.length)]).join('');
  return `FF-${part()}-${part()}`;
}
export const isShortCode = (s: string) => /^FF-[2-9A-HJ-NP-Z]{4}-[2-9A-HJ-NP-Z]{4}$/.test(s.trim().toUpperCase());

const b64url = (bytes: Uint8Array) => btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
const fromB64url = (s: string) => Uint8Array.from(atob(s.replace(/-/g, '+').replace(/_/g, '/') + '==='.slice((s.length + 3) % 4)), c => c.charCodeAt(0));

async function pipe(bytes: Uint8Array<ArrayBuffer>, stream: CompressionStream | DecompressionStream): Promise<Uint8Array> {
  const out = new Blob([bytes]).stream().pipeThrough(stream);
  return new Uint8Array(await new Response(out).arrayBuffer());
}

export async function encodeFull(day: DayState): Promise<string> {
  const json = new TextEncoder().encode(JSON.stringify(day));
  if (typeof CompressionStream === 'function') return 'FF3:' + b64url(await pipe(json, new CompressionStream('deflate-raw')));
  return 'FF3J:' + b64url(json);
}
export async function decodeFull(code: string): Promise<DayState | null> {
  try {
    const s = code.trim();
    if (s.startsWith('FF3J:')) return JSON.parse(new TextDecoder().decode(fromB64url(s.slice(5))));
    if (!s.startsWith('FF3:')) return null;
    const bytes = await pipe(fromB64url(s.slice(4)), new DecompressionStream('deflate-raw'));
    return JSON.parse(new TextDecoder().decode(bytes));
  } catch { return null; }
}
